import { Record, Map } from "immutable";

const DevicesStateRecord = Record({
  devices: Map(),
  loading: false,
  error: null,
  pairingSerialNumber: null
});

export default DevicesStateRecord;
